var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrivals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.075 2.9H9.408a.5.5 0 000 1h1.667a1.158 1.158 0 011.158 1.158v7.617a1.159 1.159 0 01-1.158 1.158H2.492a1.158 1.158 0 01-1.159-1.158V5.058A1.158 1.158 0 012.492 3.9h1.666a.5.5 0 000-1H2.492A2.158 2.158 0 00.333 5.058v7.617a2.159 2.159 0 002.159 2.158h8.583a2.167 2.167 0 002.158-2.158V5.058A2.167 2.167 0 0011.075 2.9z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15 6.85a.508.508 0 000 .708l2.267 2.267a.5.5 0 00.549.112.467.467 0 00.159-.112l2.283-2.283a.492.492 0 000-.709.508.508 0 00-.708 0L7.283 8.258V1a.5.5 0 00-1 0v7.275L4.858 6.85a.508.508 0 00-.708 0z",
    fill: "#fff"
  })));
}
export default SvgArrivals;